/** Strips common trailing/clinging punctuation from a subtitle word. */
export function stripSubtitlePunctuation(text: string): string {
  return text.trim().replace(/[.?!,]/g, '');
}
